import React, { useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Pages } from "../../Navigation/Routers/root";
import { glyphs, frames, colors } from "../../Styles";
import { Button, QuickEntryModalLvl1, QuickEntryModalLvl2, QuickEntryModalLvl3, PageHeader } from "../../Components";
import { ButtonTypes, QuickEntry, quickEntryChange } from "../../Definitions";
import { PanelMaintainAnimal } from "../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/maintainAnimalInfoCall";
import { useAppSelector } from "../../Store";
import { Graph_QL } from "../../Services";
import { useAnimal } from "../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/useAnimal";

export default function OP_QuickEntry() {
  const {t} = useTranslation()
  const [currentQuickEntryLevel, setCurrentQuickEntryLevel] = useState(1);
  const [quickEntryData, setQuickEntryData] = useState<QuickEntry[]>([]);
  const [quickEntryChange, setQuickEntryChange] = useState<quickEntryChange[]>([]);

    const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
    const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
    const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);
    const { data: animalsState, maintainEntries: updateAnimals } = useAnimal(connection);
    const dirtRef = useRef<PanelMaintainAnimal[]>([]);

  // Function to handle Quick Entry Modal based on level
  const ShowQuickEntry = (level: 0 | 1 | 2 | 3) => {
    setCurrentQuickEntryLevel(level);
  };

  // Function to handle "Go Back"
  const onGoBack = () => {
    if (currentQuickEntryLevel === 3) {
      ShowQuickEntry(2); // Go back to Level 2
    } else if (currentQuickEntryLevel === 2) {
      ShowQuickEntry(1); // Go back to Level 1
    } 
  }

  const _subheader = (
    currentQuickEntryLevel === 1 ? t("animalPages.animals.selectAnimals", {defaultValue: "select animals"})
    : currentQuickEntryLevel === 2 ? t("animalPages.animals.action", {defaultValue: "action"})
    : t("animalPages.animals.viewChanges", {defaultValue: "view changes"})
  )

  return (
    <frames.Page_inner_operations>
          <frames._page_inner_header>
            <PageHeader topHeader={t(`menuHeaders.${Pages.op_quickEntry}`, {defaultValue: "operations"})} subHeader={_subheader}/>
          </frames._page_inner_header>
          <frames._page_inner_content>
            <div style={{display: "grid", gridTemplateRows: "1fr 20px", gridTemplateColumns: "1fr", gap: "20px", height: "100%"}}>

              <div style={{gridArea: "1/1/2/2", borderTop: "2px solid "+colors.greyDarkPrimary, borderBottom: "2px solid "+colors.greyDarkPrimary, padding: "20px 0px", boxSizing: "border-box", overflowY: "scroll", scrollbarWidth: "thin", scrollbarColor: colors.greyDarkPrimary+colors.transparent}}>
                {currentQuickEntryLevel === 1 && <QuickEntryModalLvl1 quickEntryData={quickEntryData} onQuickEntryDataChange={setQuickEntryData} operationsView/>}
                {currentQuickEntryLevel === 2 && <QuickEntryModalLvl2 quickEntryChange={quickEntryChange} onQuickEntryChange={setQuickEntryChange} operationsView/>}
                {currentQuickEntryLevel === 3 && <QuickEntryModalLvl3 quickEntryData={quickEntryData} quickEntryChange={quickEntryChange} dirtyDataRef = {dirtRef}/>}      
              </div>

              <div style={{gridArea: "2/1/3/2", display: "grid", gridTemplateColumns: "90px 1px 90px", gridTemplateRows: "20px", gap: "20px", margin: "0 auto"}}>
                <div style={{gridArea: "1/1/2/2", textAlign: "right"}}>
                  { !(currentQuickEntryLevel === 1) ?
                  <Button 
                    content={t("buttons.prev", {defaultValue: "Previous"})}
                    startEnhancer={glyphs.Arrow({rotate: 180})}
                    onClick={onGoBack} 
                    buttonType={ButtonTypes.textButton}
                    overrides={{
                      baseButton: {whiteSpace: "nowrap"},
                    }}
                  /> : <></> }
                </div>
                <div style={{gridArea: "1/2/2/3", backgroundColor: colors.greyDarkPrimary}}/>
                <div style={{gridArea: "1/3/2/4"}}>
                  <Button 
                    content={currentQuickEntryLevel === 1||currentQuickEntryLevel === 2 ? t("buttons.next", {defaultValue: "next"}) : t("buttons.create", {defaultValue: "create"})}
                    endEnhancer={currentQuickEntryLevel === 1||currentQuickEntryLevel === 2 ? glyphs.Arrow({}) : <></>}
                    onClick={currentQuickEntryLevel === 1 ? () => setCurrentQuickEntryLevel(2) : currentQuickEntryLevel === 2 ? () => setCurrentQuickEntryLevel(3) : () => {} } 
                    buttonType={ButtonTypes.textButton}
                    overrides={{
                      baseButton: {whiteSpace: "nowrap"}
                    }}
                  />
                </div>
              </div>
            </div>
          </frames._page_inner_content>
        </frames.Page_inner_operations>
  
  );
}